import TimeAndDayInsights from "features/analytics/components/TimeAndDayInsights";

function TimeAndDayInsightsPage() {
  return <TimeAndDayInsights />;
}

export default TimeAndDayInsightsPage;
